export const KD9_CONTACT = Object.freeze({
  phoneDisplay: "+57 300 604 0757",
  phoneE164: "+573006040757",
  whatsappUrl: "https://wa.me/573006040757",
  supportWhatsappUrl:
    "https://wa.me/573006040757?text=Hola%20Khaos%20Delta%209%2C%20necesito%20ayuda%20con%20la%20plataforma%20KD9.",
  email: "khaosdelta9@gmail.com",
  supportEmailUrl:
    "mailto:khaosdelta9@gmail.com?subject=Solicitud%20de%20soporte%20KD9&body=Hola%20equipo%20KD9%2C%0A%0ANecesito%20ayuda%20con%3A%20",
  location: "Medellín (Antioquia)",
  mapUrl: "https://www.google.com/maps/search/?api=1&query=Medell%C3%ADn%2C%20Antioquia",
});

export const KD9_SOCIALS = Object.freeze([
  {
    key: "instagram",
    label: "Instagram",
    href: "https://www.instagram.com/khaosdelta9?igsi=MWJscHY3NGVwY2Vlcg==",
  },
  {
    key: "tiktok",
    label: "TikTok",
    href: "https://www.tiktok.com/@khaosdelta9?_r=1&_t=ZS-99H6OdiqoSu",
  },
  {
    key: "youtube",
    label: "YouTube",
    href: "https://www.youtube.com/@KhaosDelta9",
  },
  {
    key: "facebook",
    label: "Facebook",
    href: "https://www.facebook.com/share/1HBwRnHPwo/",
  },
]);
